<template>
	<div class="">
		<ul class="flex-wrap">
      <li @click="addImg" class="mr-12 add_img_icon b-radius-6 text-center pt-26 mb-12 box-s wh_106-90 bb_fo bg_FA" :class="{ 'mb_0':  imgList.length <= 2 }" v-if="imgList.length < 9 && showAdd" >
        <img class="wh_22_18 m0-auto mb-7" src="../assets/img/icon/camer.png" alt="">
        <div class="fw-500 c1 fz-12">图片上传</div>
        <input
          style="display: none"
          ref="input"
          type="file"
          accept="image/gif, image/jpeg, image/jpg, image/png, image/svg"
          multiple="multiple"
          @change="fileChange"
        >
      </li>
      <li class="b-radius-6 wh_106-90 mr-12 pr mb-12" :class="{ 'mb_0':  imgList.length <= 2 || (imgList.length == 9 && index > 5) || (imgList.length > 2 && imgList.length < 9 && (index + (showAdd? 1: 0)) > ((imgList.length + (showAdd? 0: -1)) - ((imgList.length + (showAdd? 1: 0)) % 3 == 0? 3 :  ((imgList.length + (showAdd? 1: 0)) % 3 == 2?2:1) ) ) )}" v-for="(item, index) in imgList" :key="index">
        <img class="wh_20 left_postion" @click="delImg(index)" v-if="showDel" src="../assets/img/icon/anser_del.png" alt="" >
        <img class="wh_100 b-radius-6" @click="getPrever(index)" v-if="item.path" :src="item.path" alt="">
        <img class="wh_100 b-radius-6" @click="getPrever(index)" v-else :src="item" alt="">
      </li>
    </ul>
    
	</div>
</template>
<script>
  import { ImagePreview } from 'vant';
  import { uploadFile } from '@/api/api.js'
	export default {
		props: {
			imgList: {
				type: Array,
				default: []
			},
      showDel: {
        type: Boolean,
        default: true
      },
      showAdd: {
        type: Boolean,
        default: true
      },
      isAnswer: {
        type: Boolean,
        default: false
      }
		},
		data() {
			return {
			}
		},
    created(){
      console.log(this.imgList)
    },
		mounted() {},
		methods: {
      addImg(){
        if(this.isAnswer) return
        this.$refs.input.click()
      },
      delImg(index){
        if(this.isAnswer) return
        this.$emit('delImg',index)
      },
      fileChange(file){
        // console.log(this.$refs.input.files,'this.$refs.input.files')
        let data = Array.from(this.$refs.input.files).every(item => item.type == 'image/gif' || item.type == 'image/jpeg' || item.type == 'image/jpg' || item.type == 'image/png' || item.type == 'image/svg' )
        if(!data){
          return this.$toast('文件格式不正确')
        }
        Array.from(this.$refs.input.files).forEach(async item => {
          const formData = new FormData()
          formData.append('file', item)
          const res = await uploadFile(formData)
          if(res.code == 1000){
            this.$emit('addImg', res.data)
          } else{
            this.$toast(res.msg)
          }
        })
        
      },
      getPrever(index){
        ImagePreview({
          images: this.imgList,
          startPosition: index,
        });
      }
		}
	}
</script>
<style lang="less" scoped>
ul li:nth-child(3n) {
  margin-right: 0;
}

.left_postion {
  position: absolute;
  top: -4px;
  right: -4px;
}

.mb_0 {
  margin-bottom: 0;
}
</style>
